import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';
import type SessionContextService from 'tio-employee/services/session-context';
import type StoreService from 'ember-data/store';
import type AccountModel from 'tio-data/models/account';
import type PersonModel from 'tio-data/models/person';

export default class AuthenticatedReimaginedLoansDetailRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;
  @service declare sessionContext: SessionContextService;
  @service declare store: StoreService;

  async model(params: Record<string, unknown>) {
    const personId = this.sessionContext.user.person.id;
    const accountId = params['account_id'] as string;

    const [person, employerContributions, dataSourceInfo] = await Promise.all([
      // @ts-expect-error type models
      this.store.findRecord<PersonModel>('person', personId, {
        include: 'accounts.financial-institution,accounts.loans,accounts.postal-address',
        reload: true,
      }),
      this.reimaginedData.fetchEmployerContributions(),
      this.reimaginedData.getDataSourceInfo(),
    ]);

    const account = person.activeAccounts?.find((a: AccountModel) => a.id === accountId);

    return {
      account,
      person,
      accountId,
      employerContributions,
      dataSourceInfo,
    };
  }
}
